<template></template>

<script>
  import 'jquery-validation'
  import 'select2/dist/js/select2.min.js'
  
  export default {
    name: 'RegisterGrantAndFellowship',
    mounted() {
      const $form = $('.form')
      
      /**
       * select2 - Search funders
       */
      const $search = $('.search-funders')
      $search.select2({
        ajax: {
          url: '/api/v1/funders',
          dataType: 'json',
          headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
          },
          data(params) {
            return {
              q: params.term,
              page: params.page || 1,
            }
          },
          processResults(data, params) {
            params.page = params.page || 1
            
            return {
              results: data.data,
              pagination: {
                more: (params.page * 10) < data.meta.total,
              },
            }
          },
        },
      })

      /**
       * Init JQuery validation
       */
      $(() => {
        $form.validate({
          ignore: [],
          highlight: function(element, errorClass, validClass) {
            $(element).addClass('is-invalid')
          },
          unhighlight: function(element, errorClass, validClass) {
            $(element).removeClass('is-invalid')
          },
          errorPlacement: function(label, element) {
            if(element.hasClass('select2-input')) {
              label.insertAfter(element.siblings('span.select2'))
            } else if(element.is(':radio')) {
              label.insertAfter($('[data-name=\'' + element.attr('name') + '\']'))
            }
            else {
              label.insertAfter(element)
            }
            
            label.addClass('invalid-feedback')
          },
          rules: {
            funder_id: {
              required: true,
            },
            grant_name: {
              required: true,
            },
            financing_type: {
              required: true,
            },
            year: {
              required: true,
            },
            period: {
              required: true,
            },
            type: {
              required: true,
            },
            official_letter: {
              required: true,
            },
            amount: {
              required: true,
            },
            related_to_protocol: {
              required: true,
            },
            justification: {
              required: function () {
                return parseInt($(':radio[name="related_to_protocol"]:checked').val()) === 0
              },
            },
            is_responsible: {
              required: true,
            },
          },
          messages: {
            funder_id: {
              required: 'Este campo es requerido.',
            },
            grant_name: {
              required: 'Este campo es requerido.',
            },
            financing_type: {
              required: 'Este campo es requerido.',
            },
            year: {
              required: 'Este campo es requerido.',
            },
            period: {
              required: 'Este campo es requerido.',
            },
            type: {
              required: 'Este campo es requerido.',
            },
            official_letter: {
              required: 'Este campo es requerido.',
            },
            amount: {
              required: 'Este campo es requerido.',
            },
            related_to_protocol: {
              required: 'Este campo es requerido.',
            },
            justification: {
              required: 'Este campo es requerido.',
            },
            is_responsible: {
              required: 'Este campo es requerido.',
            },
          },
          submitHandler(form) {
            $('#btn-save, #btn-cancel').prop('disabled', true)
            $('#btn-save').find('.spinner-border').removeClass('d-none')
            
            form.submit()
          },
        })
  
        $form.removeClass('invisible')

        $('#btn-cancel').on('click', (e) => {
          e.preventDefault()

          history.back()
        })

        // Init currency format
        const amountInput = $("input[data-type='currency']")
        formatCurrency(amountInput, "blur")

        amountInput.on({
          keyup: function() {
            formatCurrency($(this))
          },
          blur: function() { 
            formatCurrency($(this), "blur")
          }
        })

        function formatCurrency(input, blur) {
          var inputVal = input.val()
          
          if (inputVal === "") { return }
          
          var originalLength = inputVal.length

          var caretPosition = input.prop("selectionStart")
            
          if (inputVal.indexOf(".") >= 0) {
            var decimalPos = inputVal.indexOf(".")
            var leftSide   = inputVal.substring(0, decimalPos)
            var rightSide  = inputVal.substring(decimalPos)

            leftSide = formatNumber(leftSide)

            rightSide = formatNumber(rightSide)
            
            if (blur === "blur") {
              rightSide += "00"
            }
            
            rightSide = rightSide.substring(0, 2)

            inputVal = "$" + leftSide + "." + rightSide

          } else {
            inputVal = formatNumber(inputVal)
            inputVal = "$" + inputVal
            
            if (blur === "blur") {
              inputVal += ".00"
            }
          }
          
          input.val(inputVal)

          var updatedLength = inputVal.length
          caretPosition = updatedLength - originalLength + caretPosition
          input[0].setSelectionRange(caretPosition, caretPosition)
        }

        function formatNumber(n) {
          return n.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        }

        /**
         * Show collapsed inputs
         */
        showInputs()
        
        $(window).on('pageshow', function() {
          showInputs()
        })
        
        function showInputs() {
          $('.show-collapse:checked').each(function(key, input) {
            let target = $($(this).attr('data-target').replace(':not(.show)', ''))
            target.addClass('show')
          })
        }
      })
    },
  }
</script>
